import { usePropertyId } from "../../../../../common/hooks/usePropertyId";
import PropertyPicturesEditor from "./PropertyPicturesEditor";

const PropertyPicturesPage = () => {
    const propertyId = usePropertyId();

    return <PropertyPicturesEditor propertyId={propertyId} />
}

export default PropertyPicturesPage;

